import * as yup from 'yup'
import { EquipmentFormProfile } from './equipment-form.profile'

export const schema = (): yup.ObjectSchema<EquipmentFormProfile> =>
  yup.object({
    id: yup.number().optional(),
    name: yup.string().label('Name').emptyAsUndefined().required(),
    description: yup.string().label('Description').emptyAsUndefined(),
    equipmentType: yup.string().label('Equipment Type').emptyAsUndefined().required(),
    isActive: yup.boolean().label('Status').required(),
    maxStackingHeight: yup.number().label('Max stacking height').min(0).emptyAsUndefined(),
    maxLiftWeight: yup.number().label('Max lift weight').min(0).emptyAsUndefined(),
    yardBlockIds: yup.array(),
    yardBlockAssignments: yup.array(),
    isOwned: yup.boolean().label('Is owned').required(),
  })
